export default {
  home: {
    androidIos: "APP开发",
    weixin: "小程序开发",
    gongzhonghao: "软件开发",
    web: "网站开发"
  }
}
